if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      if (!this.form) return;
      const id = this.form.querySelector('[name="id"]');
      if (id) id.disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.submitButton = this.querySelector('[type="submit"]');
    }

    async onSubmitHandler(event) {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (!this.submitButton || this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();
      this.submitButton.setAttribute('aria-disabled', 'true');
      this.submitButton.classList.add('loading');
      const spinner = this.querySelector('.loading-overlay__spinner');
      if (spinner) spinner.classList.remove('hidden');

      try {
        const data = new FormData(this.form);
        const root = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';
        const response = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: data
        });
        const result = await response.json();
        if (!response.ok || result.status) {
          throw new Error(result.description || result.message || 'Unable to add this item.');
        }

        // Refresh the existing cart count without altering the client's header markup.
        try {
          const cartResponse = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } });
          const cart = await cartResponse.json();
          document.querySelectorAll('.cart-count-bubble, [data-cart-count], .sbd-cart-count').forEach(el => {
            if (el.classList.contains('cart-count-bubble')) {
              const number = el.querySelector('span[aria-hidden="true"]');
              if (number) number.textContent = cart.item_count;
              const screenReader = el.querySelector('.visually-hidden');
              if (screenReader) screenReader.textContent = cart.item_count + ' items';
            } else {
              el.textContent = cart.item_count;
            }
          });
          const cartIcon = document.querySelector('#cart-icon-bubble');
          if (cartIcon && !cartIcon.querySelector('.cart-count-bubble') && cart.item_count > 0) {
            const bubble = document.createElement('div');
            bubble.className = 'cart-count-bubble';
            const number = document.createElement('span');
            number.setAttribute('aria-hidden', 'true');
            number.textContent = cart.item_count;
            bubble.appendChild(number);
            cartIcon.appendChild(bubble);
          }
        } catch (cartError) {
          console.warn('Cart count refresh failed:', cartError);
        }

        this.showToast('Added to cart!', result.product_title || result.title || 'Your item', false);
        document.dispatchEvent(new CustomEvent('sbd:cart-updated', { detail: result }));
      } catch (error) {
        this.handleErrorMessage(error.message);
        this.showToast('Could not add to cart', error.message, true);
      } finally {
        this.submitButton.classList.remove('loading');
        this.submitButton.removeAttribute('aria-disabled');
        if (spinner) spinner.classList.add('hidden');
      }
    }

    showToast(title, message, isError) {
      let toast = document.getElementById('sbd-cart-toast');
      if (!toast) {
        toast = document.createElement('div');
        toast.id = 'sbd-cart-toast';
        toast.setAttribute('role', 'status');
        toast.setAttribute('aria-live', 'polite');
        Object.assign(toast.style, {
          position: 'fixed', right: '20px', bottom: '20px', zIndex: '2147483647',
          background: '#fff', color: '#222', borderRadius: '10px',
          boxShadow: '0 8px 32px rgba(0,0,0,.18)', padding: '16px 22px',
          maxWidth: 'min(370px, calc(100vw - 40px))', fontFamily: 'inherit',
          borderLeft: '4px solid #259b62', transition: 'opacity .2s ease'
        });
        document.body.appendChild(toast);
      }
      toast.style.borderLeftColor = isError ? '#c0392b' : '#259b62';
      toast.style.opacity = '1';
      toast.replaceChildren();
      const heading = document.createElement('div');
      heading.style.fontWeight = '600';
      heading.style.marginBottom = '4px';
      heading.textContent = (isError ? '!' : '✓') + ' ' + title;
      const detail = document.createElement('div');
      detail.style.fontSize = '13px';
      detail.textContent = message;
      toast.append(heading, detail);
      clearTimeout(window.sbdCartToastTimer);
      window.sbdCartToastTimer = setTimeout(() => { toast.style.opacity = '0'; }, 4500);
    }

    handleErrorMessage(errorMessage = false) {
      const wrapper = this.querySelector('.product-form__error-message-wrapper');
      if (!wrapper) return;
      const message = wrapper.querySelector('.product-form__error-message');
      wrapper.toggleAttribute('hidden', !errorMessage);
      if (message && errorMessage) message.textContent = errorMessage;
    }
  });
}
